import { exportsModule } from '@cian/mf-registry/browser';

import { buildAPIRuntime } from './api';
import { createCustomElementConstructor } from './createCustomElementConstructor';
import { createApplicationContext } from '../services/applicationContext/createApplicationContext';
import { createApplicationState } from '../services/applicationState';
import { init as initAuthContext } from '../services/authContext';
import { init as initEvents } from '../services/events';

export function start() {
  const context = createApplicationContext();
  const store = createApplicationState(context);

  initAuthContext(context, store);
  initEvents(context, store, false);

  exportsModule({
    ui: {
      '/v3/get-header-microfrontend/': () => ({
        customElementConstructor: createCustomElementConstructor(context, store),
      }),
    },
    api: () => buildAPIRuntime(store),
  });
}
